import React from 'react';

import { useSignedUrl } from '../utils/useSignedUrl';

interface PackageIconProps {
    fileId?: string;
    alt?: string;
    className?: string;
    style?: React.CSSProperties;
    defaultImage?: string;
}

/**
 * Component that displays a package icon using signed URLs for private GCS buckets
 * @param fileId - The ID of the remote file
 * @param alt - Alt text for the image
 * @param className - CSS class name
 * @param style - Inline styles
 * @param defaultImage - Default image to show if no fileId or while loading
 */
export const PackageIcon: React.FC<PackageIconProps> = ({
    fileId,
    alt = 'Package',
    className = '',
    style = {},
    defaultImage = '/assets/default-package.png',
}) => {
    const signedUrl = useSignedUrl(fileId);

    // Use signed URL if available, otherwise use default image
    const imageUrl = signedUrl || defaultImage;

    return <img src={imageUrl} alt={alt} className={className} style={style} />;
};
